module.exports = (
  $scope,
  $stateParams,
  $uibModal,
  ManualSourceBreakdown
  ) ->

  # =========================
  # -------- Actions --------
  # =========================

  $scope.checkComplete = (source) ->
    source.saving = true
    source.$update().then () ->
      source.saving = false

  $scope.uploadDoc = (source) ->
    requestModal = $uibModal.open
      template: require('../../../../StarredDocumentUpload/starred-doc-upload-modal.html')
      controller: 'StarredDocumentUploadController'
      size: 'lg'
      resolve:
        workflowStep: () ->
          return $scope.step
        manualSource: () ->
          return source.id
    requestModal.result.then (starredDocuments) ->
      if starredDocuments.docs[0]
        ($scope.manualUploads[starredDocuments.docs[0].manual_source] ?= []).push starredDocuments.docs...
        $scope.$emit( 'Starred Doc changed' )

  $scope.setFilter = (filter) ->
    $scope.filter = filter

  $scope.sourceCanHaveDataConcierge = ( manual_source ) ->
    return manual_source['created_by'] != 'custom_source'

  # =========================
  # --------- Scope ---------
  # =========================

  $scope.filter = 'todo'

  $scope.$on 'manual source state changed', ()->
    $scope.sourceBreakdown.refresh()

  $scope.$watch( 'manualSources', () ->
    $scope.sourceBreakdown = new ManualSourceBreakdown( $scope.manualSources || [] )
  )
